module.exports = __webpack_public_path__ + "img/2021compiler1.22bd6971.png";